import httpService from "./http.service";

class AccessoriesService {
  getAccessoriesUrl = "/accessories";
  getAccessoryCategoriesUrl = "/accessories/categories";
  getAccessoriesColorsUrl = "/accessories/colors/";

  createAccessory = (model) => {
    return httpService.post("/accessories", model);
  };
  editAccessory = (id, model) => {
    return httpService.patch("/accessories/" + id, model);
  };

  createAccessoryCategory = (model) => {
    return httpService.post("/accessories/categories", model);
  };
  editAccessoryCategory = (id, model) => {
    return httpService.patch("/accessories/categories/" + id, model);
  };
  deleteAccessory = (id) => {
    return httpService.delete("/accessories/" + id);
  };

  createAccessoryColor = (model) => {
    return httpService.form(
      "/accessories/colors",
      this.accessoryColorFormModel(model),
      "createAccessoriesColor"
    );
  };
  editAccessoryColor = (id, model) => {
    return httpService.form(
      "/accessories/colors/" + id,
      this.accessoryColorFormModel(model),
      "editAccessoriesColor",
      {},
      "patch"
    );
  };
  deleteAccessoryColor = (id) => {
    return httpService.delete("/accessories/colors/" + id);
  };
  deleteAccessoryCategory = (id) => {
    return httpService.delete("/accessories/categories/" + id);
  };
  getAccessoryCategories = () => {
    return httpService.get(this.getAccessoryCategoriesUrl);
  };
  uploadAccessoryImg = (id, model) => {
    let formData = new FormData();
    model.images.filter(item => item).forEach(it => {
        formData.append("images", it)
    })
    formData.append("deletedFile", JSON.stringify(model.deletedFile))

    return httpService.form("/accessories/gallery/" + id, formData, "uploadAccessoryImg", {}, "patch");
};

  accessoryColorFormModel(model) {
    const { images, ...others } = model;
    const formData = new FormData();
    for (const [key, value] of Object.entries(others)) {
      formData.append(key, value);
    }
    if (images.length) {
      images.forEach((img) => {
        formData.append("images", img);
      });
    } else {
      formData.append("images", "");
    }
    return formData;
  }
}

const accessoriesService = new AccessoriesService();
export default accessoriesService;
